import dayjs from "dayjs";

export const formatDateWithFallback = (
  value: string | null | undefined,
  fallback: string,
  options?: {
    includeTime?: boolean;
    format?: string;
  }
): string => {
  if (!value) return fallback;
  const parsed = dayjs(value);
  if (!parsed.isValid()) return fallback;

  const includeTime = options?.includeTime ?? true;
  const formatString =
    options?.format ?? (includeTime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY");

  return parsed.format(formatString);
};
